import MetricValue from './MetricValue';

export default MetricValue;

export type { IMetricValueProps } from './MetricValue';
